
document.getElementById('from-contact').reset();

const inputEmail = document.getElementById('email');
const firstName = document.getElementById('prenom');
const lastName = document.getElementById('nom');
const tel = document.getElementById('tel');
const submit = document.getElementById('submitButton')
const checkbox = document.getElementById('checkbox')
const MAXCHARNAMEFIELD = 20
const MINCHARNAMEFIELD = 2

submit.setAttribute("disabled", "true");

let checkboxValidated = false
let firstNameValidated = false
let phoneValidated = false
let lastNameValidated = false
let emailValidated = false

// EVENT LISTENERS

firstName.addEventListener("change", (event) => {
    validateFirstName(event.target.value)
});

lastName.addEventListener("change", (event) => {
    validateLastName(event.target.value)
});

inputEmail.addEventListener("change", (event) => {
    validateEmail(event.target.value)
});

tel.addEventListener("change", (event) => {
    validatePhoneNumber(event.target.value)
});

checkbox.addEventListener("change", (event) => {
    validateCheckbox(event.target)
});

submit.addEventListener("click", (event) => {
    setTimeout(() => {
        document.getElementById('from-contact').reset();
    }, "1000")
});


function submitCheck() {
    console.log(firstNameValidated, lastNameValidated, emailValidated, checkboxValidated, phoneValidated)
    if (firstNameValidated && lastNameValidated && emailValidated && checkboxValidated && phoneValidated) {
   
      submit.disabled = false;              //button is no longer no-clickable
      submit.removeAttribute("disabled");   //detto
    }
}

function validateRegexString(email) {
    return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      ); 
}

function validatePhoneNumber(phoneInputField){
    const icon = document.getElementById('telCheckIcon')
    const telActionHint = document.getElementById('telActionHint')
    if(new RegExp(/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/).test(phoneInputField)){
        phoneValidated = true
        // input box color
        tel.classList.remove('is-danger')
        tel.classList.add('is-success')
        // icon type
        icon.classList.remove('fa-exclamation-triangle')
        icon.classList.add('fa-check')
        telActionHint.style = 'display:none'
        submitCheck()
    } else {
        tel.classList.remove('is-success')
        tel.classList.add('is-danger')
        // icon type
        icon.classList.remove('fa-check')
        icon.classList.add('fa-exclamation-triangle')
        telActionHint.style = 'display:block'
        phoneValidated = false
        submit.setAttribute("disabled", "true");
    }
}

function validateName(value, input, icon){
    const conditions =
        (value != null) &&
        (value.length > MINCHARNAMEFIELD) &&
        (value.length < MAXCHARNAMEFIELD)
   
    if (conditions) {
      // input box color
      input.classList.remove('is-danger')
      input.classList.add('is-success')
      // icon type
      icon.classList.remove('fa-exclamation-triangle')
      icon.classList.add('fa-check')
      // console.log("icon :" + icon.classList.value)
   
      //now we call submit button test
      return true;
    } else {
      // input box color
      input.classList.remove('is-sucess')
      input.classList.add('is-danger')
      // icon type
      icon.classList.remove('fa-check')
      icon.classList.add('fa-exclamation-triangle')
   
      return false
    }
}

function validateLastName(value) {
    const icon = document.getElementById('lastNameCheckIcon')
    lastNameValidated = validateName(value, lastName, icon)
    submitCheck()
}

function validateFirstName(value) {
    const icon = document.getElementById('firstNameCheckIcon')
    firstNameValidated = validateName(value, firstName, icon)
    submitCheck()
}

function validateEmail(value) {
    const iconEmail = document.getElementById('emailCheckIcon')
    const emailParagraph = document.getElementById('emailActionHint')
    if (validateRegexString(value)) {
      // input box color
      inputEmail.classList.remove('is-danger')
      inputEmail.classList.add('is-success')
      // icon type
      iconEmail.classList.remove('fa-exclamation-triangle')
      iconEmail.classList.add('fa-check')
      emailParagraph.style = 'display:none'
   
      emailValidated = true
    } else {
      // input box color
      inputEmail.classList.remove('is-success')
      inputEmail.classList.add('is-danger')
      // icon type
      iconEmail.classList.remove('fa-check')
      iconEmail.classList.add('fa-exclamation-triangle')
      emailParagraph.style = 'display:block'
   
      emailValidated = false
      submit.setAttribute("disabled", "true");
    }
    submitCheck()
}

function validateCheckbox(checkbox) {
    //console.log(checkbox)
    if(checkbox.checked){
        checkboxValidated = true
    } else {
        checkboxValidated = false
        submit.setAttribute("disabled", "true");
    }
    submitCheck()
}
